/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React, { type ErrorInfo } from "react";
import { addReactError } from "@datadog/browser-rum-react";

import "./style.less";
import { Button } from "antd";
import errorImage from "../../assets/images/error.png";

class ErrorBoundary extends React.Component<
  { children: any },
  { hasError: boolean; error: any; info: any }
> {
  public static getDerivedStateFromError() {
    return { hasError: true };
  }

  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(props: any) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  public componentDidCatch(error: Error, info: ErrorInfo) {
    console.error(error, info);
    addReactError(error, info);
    this.setState({ hasError: true, error, info });
  }

  private readonly handleRetry = () => {
    this.setState({ hasError: false, error: null, info: null });
  };

  public render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary-container">
          <img src={errorImage} alt="error" style={{ width: 500 }} />
          <h1 className="error-heading">The page could not be loaded</h1>
          <p className="error-description">
            Sorry, we had a problem loading this page. Please try again.
          </p>
          <Button
            className="error-retry-btn"
            size="large"
            onClick={this.handleRetry}
          >
            Try Again
          </Button>
        </div>
      );
    }
    return this.props.children;
  }
}

export { ErrorBoundary };
